import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClickhouseService } from '../../../../../shared/services/clickhouse.service';

@Component({
  selector: 'app-answer-type-modal',
  templateUrl: './answer-type-modal.component.html',
  styleUrls: ['./answer-type-modal.component.scss'],
})
export class AnswerTypeModalComponent {
  @Input() data!: any;

  @Output() answerTypeSet: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private clickHouse: ClickhouseService,
  ) {}

  // detailed - это пошаговое
  // answer - только ответ
  setAnswerType(type: string) {
    this.spinner.show();
    this.activeModal.close();
    this.answerTypeSet.emit({
      ...this.data,
      comment_answer: type,
    });
    this.clickHouse
      .storeEvent(type === 'answer' ? 'only_answer_click' : 'step_by_step_click')
      .subscribe(() => {
        this.spinner.hide();
      });
  }
}
